import { Box, Link } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram"; // Instagram icon
import YouTubeIcon from "@mui/icons-material/YouTube"; // YouTube icon
import { ReactComponent as SteamIcon } from "./steamIcon.svg"; // Adjust path if needed

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSteam } from "@fortawesome/free-brands-svg-icons";

export default function Socials() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
      <Link
        href="https://store.steampowered.com/app/3580260?utm_source=peasantgamessite"
        target="_blank"
        sx={{
          display: "flex",
          alignItems: "center",
          mx: 5,
          "&:hover svg": {
            // Change color of the icon on hover
            color: "brightText.primary", // Set your desired hover color here
          },
        }}
      >
        <FontAwesomeIcon
          icon={faSteam}
          style={{ width: "80px", height: "70px", color: "#806252" }}
        />
      </Link>
      <Link
        href="https://www.instagram.com/peasant.games"
        target="_blank"
        sx={{
          display: "flex",
          alignItems: "center",
          mx: 5,
          "&:hover svg": {
            // Change color of the icon on hover
            color: "brightText.primary", // Set your desired hover color here
          },
        }}
      >
        <InstagramIcon sx={{ fontSize: 80, color: "#806252" }} />
      </Link>
      <Link
        href="https://www.youtube.com/@Peasant-Games"
        target="_blank"
        sx={{
          display: "flex",
          alignItems: "center",
          mx: 5,
          "&:hover svg": {
            // Change color of the icon on hover
            color: "brightText.primary", // Set your desired hover color here
          },
        }}
      >
        <YouTubeIcon sx={{ fontSize: 80, color: "#806252" }} />
      </Link>
    </Box>
  );
}
